import React, { FC, useEffect, useState } from "react";
import { INITIAL_SELL_PERMISSION_CONFIG_COUNT } from "../../../../../common/constants/common.constants";
import { ISellPermissionConfig } from "../../../../../common/interfaces/clubs.interface";
import SellPermissionItem from "./SellPermissionItem/SellPermissionItem";

import edit from "../../../../../assets/edit.svg";
import "./SellPermissions.scss";

const SellPermissions: FC<{
  permissions: ISellPermissionConfig[];
  permissionsAmount: number;
  divideByLamports: boolean;
  mintSymbol: string;
  mintDecimals: number;
  tradeRanges: boolean;
  showEditIcon?: boolean;
  onEditIconClick?: () => void;
}> = ({
  permissions,
  permissionsAmount,
  divideByLamports,
  showEditIcon,
  onEditIconClick,
  mintSymbol,
  tradeRanges,
  mintDecimals,
}) => {
  const [sellPermissions, setSellPermissions] = useState<
    (ISellPermissionConfig | undefined)[]
  >([]);

  const [areAllSellPermissionsVisible, toggleAreAllSellPermissionsVisible] =
    useState(false);

  useEffect(() => {
    const mappedPermissions = permissions.map((permission) => {
      if (permission.to > 0) {
        return permission;
      }
    });
    setSellPermissions(mappedPermissions);
  }, []);

  const isItemBlur = (index: number) => {
    return (
      index === INITIAL_SELL_PERMISSION_CONFIG_COUNT - 1 &&
      permissionsAmount > INITIAL_SELL_PERMISSION_CONFIG_COUNT &&
      !areAllSellPermissionsVisible
    );
  };
  const showRemainingSellPermissions =
    permissionsAmount > INITIAL_SELL_PERMISSION_CONFIG_COUNT &&
    areAllSellPermissionsVisible;

  return (
    <div className="sell-permissions">
      <div className="sell-permissions__header">
        <div className="sell-permissions__label">
          <p className="sell-permissions__title">
            {tradeRanges && "Trade &"} Transfer configuration
          </p>
          {showEditIcon && (
            <img src={edit} alt="edit_icon" onClick={onEditIconClick} />
          )}
        </div>
        <p className="sell-permissions__amount">
          {permissionsAmount} configurations
        </p>
      </div>
      <div className="sell-permissions__list">
        {permissionsAmount > 0 &&
          sellPermissions
            .slice(0, INITIAL_SELL_PERMISSION_CONFIG_COUNT)
            .map((permission, index) => {
              if (permission) {
                return (
                  <SellPermissionItem
                    divideByLamports={divideByLamports}
                    permissionIndex={index}
                    sellPermission={permission}
                    isItemBlur={isItemBlur(index)}
                    isItemLast={index === permissionsAmount - 1}
                    key={index}
                    mintSymbol={mintSymbol}
                    mintDecimals={mintDecimals}
                  />
                );
              }
            })}
        {showRemainingSellPermissions &&
          sellPermissions
            .slice(4, permissionsAmount)
            .map((permission, index) => {
              if (permission) {
                return (
                  <SellPermissionItem
                    divideByLamports={divideByLamports}
                    permissionIndex={4 + index}
                    sellPermission={permission}
                    isItemLast={
                      index + INITIAL_SELL_PERMISSION_CONFIG_COUNT ===
                      permissionsAmount - 1
                    }
                    mintSymbol={mintSymbol}
                    mintDecimals={mintDecimals}
                  />
                );
              }
            })}
        {permissionsAmount > INITIAL_SELL_PERMISSION_CONFIG_COUNT && (
          <button
            type="button"
            className="sell-permissions__view-all"
            onClick={() =>
              toggleAreAllSellPermissionsVisible((prevValue) => !prevValue)
            }
          >
            View all {permissionsAmount} configurations
          </button>
        )}
      </div>
    </div>
  );
};

export default SellPermissions;
